import { PaywallOfferPageVariant } from '@/services/settingsService/settingsTypes';

export function getPaywallOfferPageVariant(
  value?: unknown
): PaywallOfferPageVariant {
  return value === 'pcp' || value === 'ocp' ? value : 'control';
}

export function getPaywallPreviousAction(actionId?: string) {
  switch (actionId) {
    case 'batch_processing_cta_popup_try_subscribe_tapped':
    case 'batch_processing':
      return 'batch_processing';
    case 'video_upload_cta_popup_try_subscribe_tapped':
    case 'video_upload':
      return 'video_enhance';
    case 'output_format_conversion_cta_popup_try_subscribe_tapped':
    case 'output_format_conversion':
    case 'paywall_selection_highlighted_selected':
    case 'paywall_selection_other_selected':
    case 'download':
      return 'download';
    case 'photoshop_plugin':
      return 'plugin';
    default:
      return 'subscribe';
  }
}
